import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./primitives";

const PORTRAIT =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_objective-gauss-10/artifacts/njeugqvu_IMG_7345.jpg";

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="bg-sand py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          {/* Portrait */}
          <div className="lg:col-span-5 lg:order-2">
            <Reveal className="relative mx-auto w-full max-w-md">
              <div className="overflow-hidden rounded-[28px_28px_120px_28px] border border-line shadow-[0_30px_80px_rgba(45,48,42,0.16)]">
                <img
                  src={PORTRAIT}
                  alt="Adonica Shaw, founder"
                  data-testid="founder-portrait"
                  className="aspect-[4/5] w-full object-cover object-top"
                />
              </div>
              <span className="absolute -bottom-4 left-6 rounded-full bg-terracotta px-5 py-2 text-sm font-semibold text-white shadow-lg">
                Adonica Shaw, Advocate
              </span>
            </Reveal>
          </div>

          {/* Note */}
          <div className="lg:col-span-7 lg:order-1">
            <Reveal>
              <Eyebrow>A note from the advocate</Eyebrow>
              <Quote className="mt-6 h-10 w-10 text-terracotta/40" strokeWidth={2} />
              <blockquote className="mt-4 font-serif text-3xl font-medium leading-snug tracking-tight text-ink sm:text-4xl">
                "Sometimes healing happens alongside the people who harmed you. Sometimes the only
                justice you receive is the justice you create for yourself, and your babies. I
                started this site so that anyone feeling pressured has somewhere safe to turn, and
                someone in their corner."
              </blockquote>
              <p className="mt-8 max-w-2xl text-base leading-relaxed text-stone sm:text-lg">
                Every day, women are pushed toward a choice they don't want by the very people who
                should protect them. I later dismissed my restraining order on the advice of counsel,
                and after intimidation from women in his family at the courthouse. At the time,
                reproductive coercion was not recognized under California family law. Today, it is.
              </p>
              <p className="mt-6 font-serif text-2xl italic text-sage">Adonica Shaw</p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
